/**
 * Code Block Enhancements
 * - Copy button
 * - Language badges
 * - Line numbers (optional)
 */

(function () {
  "use strict";

  // Wait for DOM to be ready
  function ready(fn) {
    if (document.readyState !== "loading") {
      fn();
    } else {
      document.addEventListener("DOMContentLoaded", fn);
    }
  }

  ready(function () {
    enhanceCodeBlocks();
  });

  function enhanceCodeBlocks() {
    var codeBlocks = document.querySelectorAll(".gh-content pre > code");

    codeBlocks.forEach(function (codeBlock, index) {
      var pre = codeBlock.parentElement;

      // Detect language from class
      var language = detectLanguage(codeBlock);

      // Wrap in container if not already wrapped
      if (!pre.parentElement.classList.contains("code-block-wrapper")) {
        var wrapper = document.createElement("div");
        wrapper.className = "code-block-wrapper";
        pre.parentNode.insertBefore(wrapper, pre);
        wrapper.appendChild(pre);

        // Add language badge
        if (language) {
          wrapper.classList.add("has-language");
          var badge = createLanguageBadge(language);
          wrapper.insertBefore(badge, pre);
        }

        // Add copy button
        var copyBtn = createCopyButton(codeBlock, index);
        wrapper.insertBefore(copyBtn, pre);
      }
    });
  }

  function detectLanguage(codeBlock) {
    var classes = codeBlock.className;
    var match = classes.match(/language-(\w+)/);

    if (match) {
      var lang = match[1];
      // Map common language names
      var languageMap = {
        js: "JavaScript",
        javascript: "JavaScript",
        ts: "TypeScript",
        typescript: "TypeScript",
        py: "Python",
        python: "Python",
        rb: "Ruby",
        ruby: "Ruby",
        go: "Go",
        rust: "Rust",
        java: "Java",
        cpp: "C++",
        c: "C",
        cs: "C#",
        csharp: "C#",
        php: "PHP",
        html: "HTML",
        css: "CSS",
        scss: "SCSS",
        sass: "Sass",
        json: "JSON",
        yaml: "YAML",
        yml: "YAML",
        xml: "XML",
        sql: "SQL",
        bash: "Bash",
        sh: "Shell",
        shell: "Shell",
        powershell: "PowerShell",
        dockerfile: "Docker",
        docker: "Docker",
        nginx: "Nginx",
        apache: "Apache",
        graphql: "GraphQL",
        swift: "Swift",
        kotlin: "Kotlin",
        dart: "Dart",
        r: "R",
        matlab: "MATLAB",
        perl: "Perl",
        haskell: "Haskell",
        elixir: "Elixir",
        clojure: "Clojure",
        scala: "Scala",
        groovy: "Groovy",
        lua: "Lua",
        vim: "Vim",
        diff: "Diff",
        git: "Git",
        makefile: "Makefile",
        plaintext: "Text",
        text: "Text",
      };

      return languageMap[lang.toLowerCase()] || lang.toUpperCase();
    }

    return null;
  }

  function createLanguageBadge(language) {
    var badge = document.createElement("div");
    badge.className = "code-language-badge";
    badge.textContent = language;
    badge.setAttribute("aria-label", "Code language: " + language);
    return badge;
  }

  function createCopyButton(codeBlock, index) {
    var button = document.createElement("button");
    button.className = "code-copy-btn";
    button.setAttribute("aria-label", "Copy code to clipboard");
    button.setAttribute("data-code-index", index);
    button.innerHTML =
      '<svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor">' +
      '<rect x="9" y="9" width="13" height="13" rx="2" ry="2" stroke-width="2"></rect>' +
      '<path d="M5 15H4a2 2 0 0 1-2-2V4a2 2 0 0 1 2-2h9a2 2 0 0 1 2 2v1" stroke-width="2"></path>' +
      "</svg>" +
      '<span class="code-copy-text">Copy</span>';

    button.addEventListener("click", function () {
      copyCodeToClipboard(codeBlock, button);
    });

    return button;
  }

  function copyCodeToClipboard(codeBlock, button) {
    var code = codeBlock.textContent;

    if (navigator.clipboard && navigator.clipboard.writeText) {
      navigator.clipboard
        .writeText(code)
        .then(function () {
          showCopySuccess(button);
        })
        .catch(function (err) {
          console.error("Failed to copy code:", err);
          fallbackCopy(code, button);
        });
    } else {
      fallbackCopy(code, button);
    }
  }

  function fallbackCopy(text, button) {
    var textArea = document.createElement("textarea");
    textArea.value = text;
    textArea.style.position = "fixed";
    textArea.style.left = "-9999px";
    textArea.style.top = "-9999px";
    document.body.appendChild(textArea);
    textArea.focus();
    textArea.select();

    try {
      document.execCommand("copy");
      showCopySuccess(button);
    } catch (err) {
      console.error("Fallback copy failed:", err);
    }

    document.body.removeChild(textArea);
  }

  function showCopySuccess(button) {
    var originalHTML = button.innerHTML;

    button.classList.add("copied");
    button.innerHTML =
      '<svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor">' +
      '<polyline points="20 6 9 17 4 12" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"></polyline>' +
      "</svg>" +
      '<span class="code-copy-text">Copied!</span>';
    button.setAttribute("aria-label", "Code copied to clipboard");

    setTimeout(function () {
      button.classList.remove("copied");
      button.innerHTML = originalHTML;
      button.setAttribute("aria-label", "Copy code to clipboard");
    }, 2000);
  }

  // Optional: Track copy events with analytics
  function trackCopyEvent(language) {
    if (typeof gtag !== "undefined") {
      gtag("event", "code_copy", {
        event_category: "engagement",
        event_label: language || "unknown",
        value: 1,
      });
    }
  }
})();
